import { combineReducers } from 'redux'
import {
  ADD_USER,
  DELETE_USER,
  MODIFY_USER,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_LOADING,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  DELETE_USER_SUCCESS,
  MODIFY_USER_SUCCESS
} from '../actions/user.js'
import {
  ADD_MEMBER,
  DELETE_MEMBER,
  MODIFY_MEMBER,
  FETCH_MEMBERS_SUCCESS,
  FETCH_MEMBERS_LOADING,
  ADD_MEMBER_SUCCESS,
  ADD_MEMBER_ERROR,
  DELETE_MEMBER_SUCCESS,
  MODIFY_MEMBER_SUCCESS
} from '../actions/member.js'
import {
  USER_SIGN_IN_SUCCES,
  USER_SIGN_IN_ERROR,
  USER_SIGN_IN,
  ADMIN_SIGN_IN,
  RESET_PASSWORD
} from '../actions/auth.js'

const user = (state = false, action) => {
  switch (action.type) {
    case USER_SIGN_IN_SUCCES:
      return action.user
    default:
      return state
  }
}

const resetPassword = (state = false, action) => {
  switch (action.type) {
    case RESET_PASSWORD:
      return action.reset
    default:
      return state
  }
}

const admin = (state = false, action) => {
  switch (action.type) {
    case ADMIN_SIGN_IN:
      return action.admin
    default:
      return state
  }
}

const isLoading = (state = true, action) => {
  switch (action.type) {
    case FETCH_MEMBERS_LOADING:
      return action.isLoading
    default:
      return state
  }
}

const users = (state = [], action) => {
  switch (action.type) {
    case FETCH_USERS_SUCCESS:
      return action.users
    default:
      return state
  }
}

const members = (
  state = {
    Associé: [],
    Adhérent: [],
    Actif: [],
    Honoraire: [],
    'de droit': [],
    error: []
  },
  action
) => {
  switch (action.type) {
    case FETCH_MEMBERS_SUCCESS:
      return action.members
    default:
      return state
  }
}

const addUser = (state = [], action) => {
  switch (action.type) {
    case ADD_USER_SUCCESS:
      return action.addUserSuccess
    case ADD_USER_ERROR:
      return action.hasError
    default:
      return state
  }
}

const modifyUser = (state = '', action) => {
  switch (action.type) {
    case MODIFY_USER_SUCCESS:
      return action.userId
    default:
      return state
  }
}

const deleteUser = (state = [], action) => {
  switch (action.type) {
    case DELETE_USER_SUCCESS:
      return action.item
    default:
      return state
  }
}

export default combineReducers({
  users,
  members,
  modifyUser,
  deleteUser,
  isLoading,
  addUser,
  user,
  admin
})



// WEBPACK FOOTER //
// ./src/reducers/index.js